import { TextArea } from '@insight-health-ai/roseate/components';
import type { InputProps } from './types';

export function Textarea({ field, value, onChange, autoFocus }: InputProps) {
  return (
    <TextArea
      value={(value as string) || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder}
      required={field.required}
      disabled={field.disabled}
      autoFocus={autoFocus}
      autoSize={{ minRows: 3 }}
      className={field.inputClassName}
    />
  );
}
